module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n    "), (_vm.allowEmpty) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('vue-multiselect', {
    attrs: {
      "options": _vm.options,
      "multiple": _vm.multiple,
      "searchable": _vm.searchable,
      "allow-empty": _vm.allowEmpty,
      "value": _vm.getSelectedMultiselectByValue(_vm.value, _vm.options, 'value'),
      "placeholder": "Выбрать",
      "selectedLabel": "Выбрано",
      "deselectLabel": "Нажимите для удаления",
      "selectLabel": "Нажимите для выбора",
      "tag-placeholder": "Нажмите Enter для добавления",
      "track-by": _vm.trackBy,
      "label": _vm.label,
      "taggable": _vm.taggable,
      "autocomplete": "off"
    },
    on: {
      "tag": _vm.addTag,
      "remove": _vm.remove,
      "input": _vm.changeValue
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-077fa0b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-077fa0b4"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Components/AdminFormComponents/AdminFormMultiSelect.vue
// module id = 995
// module chunks = 1